import React, { FC } from 'react';
import { makeStyles } from 'tss-react/mui';

import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import CircularProgress from '@mui/material/CircularProgress';

import { styles } from './styles';

const useStyles = makeStyles()(styles as Record<string, any>);

interface DeleteRecurringDialogProps {
  showDeleteRecurrenceProgress: boolean;
  recurrencePayee: string;
  recurrenceFrequency: string;
}

const DeleteRecurringDialog: FC<DeleteRecurringDialogProps> = ({
  showDeleteRecurrenceProgress,
  recurrencePayee,
  recurrenceFrequency,
}) => {

  const { classes } = useStyles();

  return (
    <Dialog open={showDeleteRecurrenceProgress}>
      <DialogContent
        className={classes.dialogContent}
      >
        <Typography variant="h5">
          Deleting recurring
        </Typography>
        <Paper className={classes.paper}>
          <Avatar sx={{ m: 2.5 }}>
            {recurrencePayee && recurrencePayee.length ? recurrencePayee[0].toUpperCase() : '*'}
          </Avatar>
          <Typography variant="h6">
            {recurrencePayee}
          </Typography>
          <Typography variant="caption">
            {recurrenceFrequency}
          </Typography>
        </Paper>
        <CircularProgress />
      </DialogContent>
    </Dialog>
  );
};

export default DeleteRecurringDialog;
